<template>
  <div class="register">
    <h2 class="section-title">
      {{ $t("register") }}
    </h2>

    <div class="section-teacher-info" v-if="$route.name === 'register-teacher'">
      <i class="fa fa-2x fa-info-circle"></i>
      <p>
        Thank you for giving vokabox a try. We really appreciate that and we
        want to use this opportunity to make 2 things clear:
      </p>
      <ol>
        <li>
          This is a software product in its testing phase - so no warranties for
          nothing - but we are rather sure vokabox could be useful for you and
          should be mostly bug-free.
        </li>
        <li>
          We are all nice ppl here @ vokabox, so don't hesitate to contact us
          via: info@vokabox.com if you have questions, suggestions, or want to
          share your favorite apple pie recipe with us :). No really, don't be
          afraid - if it's on topic we are really glad to hear from you.
        </li>
      </ol>
      <p>
        We value your trust, time and effort by giving you a free teacher
        account for at least a year (sadly we still have bills to pay, `too`) -
        without expecting to get anything back from you. Of course we hope you
        will use vokabox and give us feedback, but we won't enforce that. We
        will mail you a questionaire and maybe write you a mail or two, but we
        have no interest in nagging you. And especially we will not give away
        any of your personal data to 3rd parties, besides: Google Analytics, ...
        (for enhancing vokabox and getting some insights in its usage). This is
        what nearly every website in the www does, so please stay with us and
        keep in mind that the data these services process is anonymized.
        <br />So give vokabox a try and have a look what it can do for you:
      </p>
      <p>
        There is also a blog where you can find not only tips and "How-To's" for
        vokabox, but also some interesting posts related to learning and
        teaching German @
        <a
          href="https://blog.vokabox.com/"
          target="_blank"
          rel="noopener noreferrer"
          >https://blog.vokabox.com</a
        >
      </p>
    </div>

    <van-form @submit="onSubmit">
      <van-field
        v-model="name"
        :name="$t('name')"
        :label="$t('name')"
        :placeholder="$t('name')"
        :rules="[{ required: true, message: $t('name is required') }]"
      />
      <van-field
        v-model="email"
        :name="$t('email')"
        :label="$t('email')"
        :placeholder="$t('email')"
        :rules="[{ required: true, message: $t('email is required') }]"
      />
      <van-field
        v-model="password1"
        type="password"
        autocomplete="new-password"
        :name="$t('password')"
        :label="$t('password')"
        :placeholder="$t('password')"
        :rules="[{ required: true, message: $t('password is required') }]"
      />
      <van-field
        v-model="password2"
        type="password"
        autocomplete="new-password"
        :name="$t('confirm password')"
        :label="$t('confirm password')"
        :placeholder="$t('password')"
        :rules="[
          { required: true, message: $t('confirm password is required') }
        ]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          {{ $t("register") }}
        </van-button>
      </div>
    </van-form>
    <div class="center-me">
      <router-link :to="{ name: 'forget-password' }" style="padding-left:5px;">
        {{ $t("forgot password?") }}
      </router-link>
      <router-link :to="{ name: 'login' }" style="padding-left:5px;">
        {{ $t("login") }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "Register",
  data() {
    return {
      name: "",
      email: "",
      password1: "",
      password2: ""
    };
  },
  methods: {
    ...mapActions("account", ["register"]),
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    onSubmit() {
      const { name, email, password1, password2 } = this;
      this.register({
        name,
        email,
        password1,
        password2,
        path: this.$route.path
      });
    }
  },
  created() {
    this.SET_PAGE_TITLE(this.$t("register"));
  }
};
</script>
<style lang="scss">
@import "@/assets/styles.scss";
.section-teacher-info {
  padding: 32px 16px 16px;
  color: #323233;
  i {
    float: right;
    margin: 0 10px;
    color: #1989fa;
  }
  p {
    margin: 12px 0;
  }
  ol {
    box-sizing: border-box;
    margin-left: 40px;
    padding: 12px 0;
    list-style-type: lower-alpha;
  }
}
</style>
